import { render, staticRenderFns } from "./Wp_home_pop_model.vue?vue&type=template&id=4bd457c0&"
import script from "./Wp_home_pop_model.vue?vue&type=script&lang=js&"
export * from "./Wp_home_pop_model.vue?vue&type=script&lang=js&"
import style0 from "./Wp_home_pop_model.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports